"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverviewSettings = exports.isTagsViewConcise = void 0;
const vue_1 = require("vue");
const isTagsViewConcise = (root) => {
    return root.getVisibilityState('tags_concise');
};
exports.isTagsViewConcise = isTagsViewConcise;
exports.OverviewSettings = vue_1.default.component('overview-settings', {
    methods: {
        toggleTagsView: function () {
            this.$root.setVisibilityState('tags_concise', !this.$root.getVisibilityState('tags_concise'));
        },
        getTagToggleLabel: function () {
            return exports.isTagsViewConcise(this.$root) ? 'full' : 'concise';
        },
    },
    template: `
        <div class="players-overview-settings">
            <div class="setting-label" v-i18n>toggle tags view:</div>
            <div class="setting-button" v-on:click.prevent="toggleTagsView()">{{ getTagToggleLabel() }}</div>
        </div>
    `,
});
//# sourceMappingURL=OverviewSettings.js.map